<script lang="ts" setup>
import { mdiLock } from '@mdi/js'

interface Props {
  show: boolean
}

const props = defineProps<Props>()

const show = useVModel(props, 'show')

const { t } = useI18n({ useScope: 'local' })
</script>

<template>
  <v-banner
    v-if="show"
    bg-color="warning"
    density="compact"
    style="display: flex;"
  >
    <template #default>
      <div class="d-flex align-center justify-space-between flex-grow-1">
        <div class="d-flex align-center">
          <v-icon :icon="mdiLock" />
          <span class="ml-3">{{ t('hint') }}</span>
        </div>
      </div>
    </template>
  </v-banner>
</template>

<i18n lang="yaml">
  de:
    hint: Einige Aktionen sind deaktiviert, da die Datei bearbeitet wird. Weitere Informationen unter "Bearbeitung anfragen"
  en:
    hint: The file is currently being edited, which is why some actions are disabled. For more information, please refer to "Request Edit"
  </i18n>
